"use strict";

exports.__esModule = true;
exports["default"] = galleryReducer;

var _galleryTypes = require("../constants/galleryTypes.js");

var _videoActionTypes = _interopRequireDefault(require("../constants/videoActionTypes"));

var _itemViewActions = require("../actions/itemViewActions.js");

var _initialState = _interopRequireDefault(require("./initialState.js"));

var _lodash = _interopRequireDefault(require("lodash"));

var _utils = _interopRequireDefault(require("../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function galleryReducer(state, action) {
  if (state === void 0) {
    state = _initialState["default"].gallery;
  }

  switch (action.type) {
    case _galleryTypes.SET_WIX_DATA:
      if (action.boundingRectAndOffsets) {
        var res = action.boundingRectAndOffsets;
        var scrollBase = res.offsets.y;

        var scrollTop = -1 * res.rect.top / _utils["default"].getViewportScaleRatio();

        var maxGalleryWidth;

        if (res && res.rect && !_lodash["default"].isUndefined(res.rect.width)) {
          maxGalleryWidth = res.rect.width;
        }

        return _lodash["default"].merge({}, state, {
          wixInit: true,
          scrollBase: scrollBase,
          scrollTop: scrollTop,
          maxGalleryWidth: maxGalleryWidth
        });
      } else {
        return _lodash["default"].merge({}, state, {
          wixInit: true,
          scrollBase: 0
        });
      }

    case _videoActionTypes["default"].videoModeChanged:
      {
        var newVideoPlayMode = action.payload;
        var _state = state,
            videoPlayMode = _state.videoPlayMode;

        if (videoPlayMode !== newVideoPlayMode) {
          state = _objectSpread({}, state, {
            videoPlayMode: newVideoPlayMode
          });
        }

        break;
      }

    case _galleryTypes.SET_ITEMS:
      return _lodash["default"].merge({}, state, {
        items: action.items
      });

    case _galleryTypes.SET_RENDERED_ITEMS_COUNT:
      return _lodash["default"].merge({}, state, {
        renderedItemsCount: action.count
      });

    case _galleryTypes.GALLERY_WINDOW_LAYOUT_CHANGED:
      {
        var documentHeight = {
          documentHeight: action.documentHeight
        };
        return _lodash["default"].merge({}, state, documentHeight);
      }

    case _galleryTypes.SET_VIDEO_PLAY_INDEX:
      if (state.isInView) {
        state = _objectSpread({}, state, {
          videoIndexPlay: action.payload,
          lastVideoPlayed: action.payload
        });
      }

      break;

    case _itemViewActions.PLAY_VIDEO:
      if (state.isInView) {
        return _lodash["default"].merge({}, state, {
          videoIndexPlay: action.idx,
          lastVideoPlayed: action.idx
        });
      }

      break;

    case _itemViewActions.PAUSE_VIDEO:
      return _lodash["default"].merge({}, state, {
        videoIndexPlay: -1
      });

    case _galleryTypes.TOGGLE_HOVER_PREVIEW:
      return _lodash["default"].merge({}, state, {
        previewHover: action.toggle
      });

    case _galleryTypes.TOGGLE_ISINVIEW:
      return _lodash["default"].merge({}, state, {
        isInView: action.toggle
      });

    default:
      return state;
  }

  return state;
}